import { useFromInput } from '@ui/features/Trade/hooks/useFromInput';
import { useTradingPair } from '@ui/features/Trade/store/useTradingPair';
import { OrderType } from '@ui/types/trade';
import { useTranslation } from 'next-i18next';

import { useCollateralToken } from '../../TradeModule/store/useCollateralToken';
import { useIsLong } from '../../TradeModule/store/useIsLong';

export const useOpenLimitOrderToastOpts = () => {
  const { t } = useTranslation();

  const isLong = useIsLong((s) => s._persistValue);
  const selectedTradingPair = useTradingPair((s) => s.useTradingPair());
  const payToken = useCollateralToken((s) => s.useCollateralTokenValue());
  const inputAmount = useFromInput((s) => s.input).value.token;
  const triggerPrice = useFromInput((s) => s.input).triggerPrice;

  return {
    onMutateToastOpts: {},
    onSuccessToastOpts: {
      description: t(
        'common.Pay {payTokenAmount} {payTokenSymbol} to {tradeType} {tokenPair} with {orderType} price at {price}',
        {
          tokenPair: `${selectedTradingPair?.baseName}`,
          tradeType: isLong ? 'Long' : 'Short',
          payTokenSymbol: payToken?.displaySymbol,
          payTokenAmount: inputAmount,
          interpolation: {
            escapeValue: false,
          },
          orderType: OrderType.LIMIT,
          price: triggerPrice,
        },
      ),
    },
    onErrorToastOpts: {},
  };
};
